type SelectFieldProps = {
  label: string;
  onChange: (value: string) => void;
  options: string[];
  value: string;
};

export default function SelectField({ label, onChange, options, value }: SelectFieldProps) {
  return (
    <label className="block">
      <span className="field-label">{label}</span>
      <select className="field-input" onChange={(event) => onChange(event.target.value)} value={value}>
        {options.map((option) => (
          <option key={option || "empty"} value={option}>
            {option || "Select level"}
          </option>
        ))}
      </select>
    </label>
  );
}
